<template>
    <div>
        <button class="d-flex text-left" v-if="p_title" @click=m_openClick>
            <span class="icon">
                <svg v-if="!d_open" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                </svg>
            </span>
            {{p_title}}
        </button>
        <div class="expand" v-if="d_open">
            <slot></slot>
        </div>
    </div>
</template>

<script> 
export default {
    name: "filter-accordion",
    props: {
        p_title: {type: String},
		p_property:{type: String},
    },
    data() {
        return {d_open: false,}
    },
	mounted() {},
	methods:{
			m_openClick(){this.d_open = !this.d_open;
						//if(this.open) this.$parent.m_currentFilter(this.p_property);
				}
	
	}
}
</script>